/* eslint-disable @typescript-eslint/no-explicit-any */
import * as yup from 'yup';

import {
  LC_PAGE_COMPETENCY_CHAR_LIMIT,
  LC_PAGE_SUBJECT_CHAR_LIMIT,
} from '@lessonPlanner/constants';

const createArrayTransformSchema = () =>
  yup
    .mixed()
    .transform((value) => {
      if (typeof value === 'string') {
        try {
          return JSON.parse(value);
        } catch (error) {
          return [];
        }
      }
      return value;
    })
    .test('is-array', 'Must be an array', (value) => Array.isArray(value));

// Helper function to create a dependent field validation
const createDependentArraySchema = (dependentField: string) =>
  createArrayTransformSchema().test(
    'dependent-required',
    'This field is required when paired field has a value',
    function (value) {
      const dependentValue = this.parent[dependentField];
      const hasValue = Array.isArray(value) && value.length > 0;
      const hasDependentValue =
        Array.isArray(dependentValue) && dependentValue.length > 0;
      return (
        (!hasValue && !hasDependentValue) || (hasValue && hasDependentValue)
      );
    },
  );

export const iplanObjectiveSchema = yup.object({
  subject: yup
    .string()
    .required('Please enter a subject')
    .test(
      'len',
      'You have reached the character limit',
      (val: any) => val.length <= LC_PAGE_SUBJECT_CHAR_LIMIT,
    ),

  gradeLevel: yup.string().required('Please select a grade level'),

  competency: yup
    .string()
    .required('Please enter competency')
    .test(
      'len',
      'You have reached the character limit',
      (val: any) => val.length <= LC_PAGE_COMPETENCY_CHAR_LIMIT,
    ),

  cognitiveVerbs: createArrayTransformSchema(),
  psychomotorVerbs: createArrayTransformSchema(),

  affectiveValuesVerbs: createDependentArraySchema('valuesList'),
  affectiveValuesVerbs2: createDependentArraySchema('valuesList2'),
  affectiveValuesVerbs3: createDependentArraySchema('valuesList3'),

  affectiveAttitudesVerbs: createDependentArraySchema('attitudesList'),
  affectiveAttitudesVerbs2: createDependentArraySchema('attitudesList2'),
  affectiveAttitudesVerbs3: createDependentArraySchema('attitudesList3'),

  valuesList: createDependentArraySchema('affectiveValuesVerbs'),
  valuesList2: createDependentArraySchema('affectiveValuesVerbs2'),
  valuesList3: createDependentArraySchema('affectiveValuesVerbs3'),

  attitudesList: createDependentArraySchema('affectiveAttitudesVerbs'),
  attitudesList2: createDependentArraySchema('affectiveAttitudesVerbs2'),
  attitudesList3: createDependentArraySchema('affectiveAttitudesVerbs3'),
});

export default iplanObjectiveSchema;
